(function () {
'use strict';

angular
.module('app.performanceReportKPI')
.controller('performanceReportKPICtrl', 
    ['$scope', '$rootScope', 'measureService', 'performanceReportKPIService','$http', '$controller',
    function ($scope, $rootScope, measureService, performanceReportKPIService, $http, $controller){
       
        //Watch on change keyword / blog / project change
        $scope.$on('refreshDashboard', function(event, args) {
            getDataPerformanceReportKPI();
        });

        function getDataPerformanceReportKPI(args) {
            var params = $rootScope.saveParams;
            if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
              return;
            } 
            params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

            getMentionKPIData(params);
        }

        function getMentionKPIData(params){
            performanceReportKPIService.getMentionKPIData(params)
                .then(function(response){
                    genMentionKPI(response.data.KPIs);
                })
                .catch(function(message){
                    $scope.generalKPIs = [
                        {name: "MENTIONS"},
                        {name: "IMPRESSIONS"},
                        {name: "REACH"},
                        {name: "ENGAGEMENT"},
                        {name: "IMPACT"}
                    ];
                })
                .finally(function(){
                    $rootScope.$broadcast('sectionLoaded');
                })            
        }

        function genMentionKPI(kPIs){
          if (kPIs != null) {
            kPIs[0].value = kPIs[0].value;
            kPIs[1].value = kPIs[1].value;
            kPIs[2].value = kPIs[2].value;
            kPIs[3].value = kPIs[3].value;
            kPIs[4].value = Math.round(kPIs[4].value);

            $scope.generalKPIs = kPIs;
          }    
        }

        // first initiating
        getDataPerformanceReportKPI();
    }]);
})();